import { createAction } from '@ngrx/store';

/**
 * Exported as a bare string as well as an action creator so that
 * `createLocalStorageSyncReducer` can recognise it without importing the
 * creator, which would close an import cycle through the store.
 */
export const SESSION_RESET = '[Session] Reset Session State';

/**
 * Drops every feature slice.
 *
 * Dispatch at each session boundary: logging out, landing on the login page,
 * the OAuth callback bailing out, an inactive-user bounce, and whenever /me
 * comes back as a different account than the one the persisted state belongs
 * to. There is no session slice; this action exists purely for the root
 * `resetStateOnSessionChange` meta-reducer.
 */
export const ResetSessionState = createAction(SESSION_RESET);

export const SessionActions = { ResetSessionState };
